import { mergeStatic } from '../operator/merge';
export var merge = mergeStatic;
//# sourceMappingURL=merge.js.map